import { boolFromUnknown, intFromUnknown, strFromUnknown } from '@/lib/primitive-utils';
import { LabeledTextRow } from './shared/field-primitives';
import { SignificantFiguresControls, sigFigUiModeFromProps } from './shared/significant-figures-controls';
import { AbsoluteValueCheckbox, ToleranceField, WidthField } from './shared/tolerance-width-fields';
import type { BuilderPropertyRecord, ShortAnswerToolSettingsProps } from './tool-defaults';

export function selectDecimalNumberToolProps(p: BuilderPropertyRecord) {
    const requireSigFig = boolFromUnknown(p.require_sig_fig);
    const requireN = intFromUnknown(p.require_n_or_fewer_sig_figs, 0);
    return {
        sigFigMode: sigFigUiModeFromProps({ require_sig_fig: requireSigFig, require_n_or_fewer_sig_figs: requireN }),
        requireNOrFewer: requireN,
        placeholder: strFromUnknown(p.placeholder, ''),
        tolerance: strFromUnknown(p.tolerance, '3%'),
        absoluteValue: boolFromUnknown(p.absolute_value),
        width: intFromUnknown(p.width, 100),
    };
}

function DecimalNumberToolSettingsInner(
    props: ReturnType<typeof selectDecimalNumberToolProps> & {
        onPatch: (patch: BuilderPropertyRecord) => void;
    },
) {
    const { sigFigMode, requireNOrFewer, placeholder, tolerance, absoluteValue, width, onPatch } = props;

    return (
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 sm:gap-x-3 sm:gap-y-2">
            <SignificantFiguresControls
                mode={sigFigMode}
                requireNOrFewer={requireNOrFewer}
                onPatch={onPatch}
            />
            <LabeledTextRow
                label="Placeholder"
                value={placeholder}
                rows={1}
                onValueChange={v => onPatch({ placeholder: v })}
            />
            <ToleranceField
                tolerance={tolerance}
                onPatch={onPatch}
            />
            <WidthField
                width={width}
                onPatch={onPatch}
            />
            <AbsoluteValueCheckbox
                absoluteValue={absoluteValue}
                onPatch={onPatch}
            />
        </div>
    );
}

export function DecimalNumberToolSettings({ builderProps, onPatch }: ShortAnswerToolSettingsProps) {
    return (
        <DecimalNumberToolSettingsInner
            {...selectDecimalNumberToolProps(builderProps)}
            onPatch={onPatch}
        />
    );
}
